import { Button } from 'antd';
import styled from 'styled-components';

import theme from '@theme';

export const StyledButton = styled(Button)`
  background-color: #ebebeb;
  transition: all 0.3s ease;
  color: #434343;
  border: none;
  height: 80px;
  border-radius: 0;
  padding: 0;
  min-width: 30px;
  @media (max-width: ${theme.breakPoint.TABLET}) {
    width: 100%;
  }
  @media (max-width: ${theme.breakPoint.PHONE}) {
    width: 100%;
  }

  &:hover {
    background-color: white;
  }

  img {
    opacity: 0.8;
  }
`;

export const Wrapper = styled.div`
  width: 250px;

  @media (max-width: ${theme.breakPoint.WIDE_DESKTOP}) {
    width: 150px;
  }
  @media (max-width: ${theme.breakPoint.DESKTOP}) {
    width: 115px;
  }
  @media (max-width: ${theme.breakPoint.TABLET}) {
    width: 100%;
  }
  @media (max-width: ${theme.breakPoint.PHONE}) {
    width: 100%;
  }

  &:hover {
    background-color: white;
  }

  img {
    opacity: 0.8;
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: ${theme.breakPoint.TABLET}) {
    flex-direction: column;
  }
`;
